import { createAsyncThunk } from "@reduxjs/toolkit";
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from "../../utils/api";
import { setAlert } from "../alerts/actions";

export const list = createAsyncThunk("roles/list", async (params = { page: 0, limit: 10, orderBy: null, orderDirection: null, filter: null, search: null }) => {
    try {
        const page = params.page ? params.page : 0
        const limit = params.limit ? params.limit : 10
        const res = await api.get(`/admin/roles`, { params });
        console.log(page, limit)
        return { ...res.data, page, limit };
    } catch (error) {
        console.log(error);
    }
});

export const create = createAsyncThunk("roles/create", async ({ data, navigate }, { dispatch }) => {
    try {
        const res = await api.post('/admin/roles', data);
        dispatch(list());
        dispatch(setAlert({ message: 'Role Added successfully', alertType: 'success' }))
        if (navigate)
            navigate(`/cms/roles`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const get = createAsyncThunk("roles/get", async (id, { dispatch }) => {
    try {
        const res = await api.get(`/admin/roles/${id}`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const edit = createAsyncThunk("roles/edit", async ({ id, data, navigate }, { dispatch }) => {
    try {
        console.log(data);
        await api.put(`/admin/roles/${id}`, data);
        dispatch(setAlert({ message: 'Role updated successfully', alertType: 'success' }))
        dispatch(list());
        if (navigate)
            navigate(`/cms/roles`);
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});


export const remove = createAsyncThunk("roles/remove", async (id, { dispatch }) => {
    try {
        await api.delete(`/admin/roles/${id}`);
        dispatch(setAlert({ message: 'Role removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const bulk_remove = createAsyncThunk("roles/bulk-remove", async ({ data }, { dispatch }) => {
    try {
        await api.post(`/admin/roles/delete`, data);
        dispatch(setAlert({ message: 'Roles removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});